import axios from "axios";

export const getDeviceOfflineDaysAPI = async params => {
  let response = await axios({
    url: `/api/v2/statistic/devices-offline-days`,
    method: "GET",
    params
  });
  const data = response.data.devices_offline_days;
  return data;
};
